import { databaseService } from '../databaseService';
import APP_CONSTANTS from '../../config/constants';
import { userActions, companyActions, type UserProfile, type CompanyProfile } from '../../state/globalState';
import { isPendingSyncSessionSnapshotStateCurrent, type PendingSyncSessionSnapshot } from './PendingSyncSession';

/** Publica os dados já recebidos pelo pull sem reconstruir Auth ou assinatura. */
export const refreshPulledIdentity = async (snapshot: PendingSyncSessionSnapshot): Promise<boolean> => {
  if (!isPendingSyncSessionSnapshotStateCurrent(snapshot)) return false;
  const profile = await databaseService.readItem<UserProfile>(APP_CONSTANTS.DATABASE.TABLES.USERS.NAME, snapshot.userId);
  const company = await databaseService.readItem<CompanyProfile>(APP_CONSTANTS.DATABASE.TABLES.EMPRESAS.NAME, snapshot.empresaId);
  if (!isPendingSyncSessionSnapshotStateCurrent(snapshot)
    || profile?.id !== snapshot.userId || profile.empresa_id !== snapshot.empresaId
    || company?.id !== snapshot.empresaId) return false;

  // Não há espera entre a revalidação da sessão e a publicação das duas linhas.
  userActions.setProfile(profile);
  companyActions.setCompanyData(company);
  return true;
};
